import {
  GetUsuryRateResponseDto
} from '@features/setting/application/use_cases/get-usury-rate/dto/get-usury-rate.response.dto';
import {
  GetUsuryRatePayloadDto
} from '@features/setting/application/use_cases/get-usury-rate/dto/get-usury-rate.payload.dto';

import {
  GetUsuryRateHttpResponseDto
} from '@features/setting/infrastructure/http/get-usury-rate/get-usury-rate.http.response.dto';
import {
  GetUsuryRateHttpPayloadDto
} from '@features/setting/infrastructure/http/get-usury-rate/get-usury-rate.http.payload.dto';

export class GetUsuryRateHttpMapper {

  static toResponse(data: GetUsuryRateHttpResponseDto): GetUsuryRateResponseDto {
    return {
      value: Number(data.usuryRate)
    }
  }

  static toInfra(data: GetUsuryRatePayloadDto): GetUsuryRateHttpPayloadDto {
    return {}
  }

}
